import { Box, Container, useMediaQuery } from '@mui/material';
import React, { memo } from 'react';
import ImageList from './image-list';
import ImagePreview from './image-preview';
import constants from '../../config/constants';
import {
  currentGalleryCarIdSet,
  galleryZoomStepSet,
  getAllGalleryImagesLow,
  getCurrentGalleryCarId,
  getGalleryZoomStep,
} from '../../store/gallery-slice';
import { useDispatch, useSelector } from 'react-redux';
import { getActiveTab } from '../../store/car-slice';

function GalleryContainer() {
  const dispatch = useDispatch();

  // Media Query
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('lg'));
  const isPortrait = useMediaQuery('(orientation: portrait)');
  // Selector
  const currentGalleryCarId = useSelector(getCurrentGalleryCarId);
  const activeTab = useSelector(getActiveTab);

  const { interiorGalleryLow, exteriorGalleryLow } = useSelector(
    getAllGalleryImagesLow,
  );

  const allGallery = React.useMemo(
    () => [...exteriorGalleryLow, ...interiorGalleryLow],
    [interiorGalleryLow, exteriorGalleryLow],
  );

  const handleClickNext = () => {
    const currentCarIndex = allGallery?.findIndex(
      (car: any) => car.id === currentGalleryCarId,
    );

    dispatch(
      currentCarIndex < allGallery?.length - 1
        ? currentGalleryCarIdSet(allGallery[currentCarIndex + 1]?.id)
        : currentGalleryCarIdSet(allGallery[0]?.id),
    );
  };

  const handleClickBack = () => {
    const currentCarIndex = allGallery?.findIndex(
      (car: any) => car.id === currentGalleryCarId,
    );

    dispatch(
      currentCarIndex === 0
        ? currentGalleryCarIdSet(allGallery[allGallery?.length - 1]?.id)
        : currentGalleryCarIdSet(allGallery[currentCarIndex - 1]?.id),
    );
  };

  const galleryZoomStep = useSelector(getGalleryZoomStep);

  const handleKeyDown = (event: any) => {
    if (activeTab === 'gallery') {
      if (event.key === 'ArrowUp') {
        if (galleryZoomStep === 1) {
          dispatch(galleryZoomStepSet(2));
        }
      }

      if (event.key === 'ArrowDown') {
        if (galleryZoomStep === 2) {
          dispatch(galleryZoomStepSet(1));
        }
      }

      if (event.key === 'ArrowRight') {
        handleClickNext();
      }

      if (event.key === 'ArrowLeft') {
        handleClickBack();
      }
    }
  };

  React.useEffect(() => {
    if (activeTab === 'gallery') {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [allGallery]);

  return (
    <Container
      maxWidth={false}
      sx={{
        position: 'absolute',
        top: 0,
        display: 'flex',
        height: '100%',
        background: 'white',
        backdropFilter: constants.BLUR_STYLE.filter,
        padding: '0 !important',
        zIndex: (theme) => theme.zIndex.drawer,
        justifyContent: isMobile && isPortrait ? 'center' : '',
        alignItems: isMobile && isPortrait ? 'center' : '',
        flexDirection: isMobile && isPortrait ? 'column-reverse' : '',
      }}
    >
      <ImageList />
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
        }}
      >
        <ImagePreview />
      </Box>
    </Container>
  );
}

export default memo(GalleryContainer);
